<template>
  <VDialog
    v-model="dialogVisible"
    :persistent="persistent"
    max-width="500px"
    content-class="dialog-plugin-content"
    @update:model-value="onDialogInput"
    @keydown.esc="handleEsc"
  >
    <VCard>
      <VCardTitle v-if="title" class="text-h5">{{ title }}</VCardTitle>
      <VCardText
        v-if="text"
        class="pt-4 showNewLine"
      >
        <div v-if="htmlMode" v-html="text">
        </div>
        <div v-else>{{ text }}</div>
      </VCardText>
      <VCardActions>
        <VSpacer></VSpacer>
        <VBtn
          v-for="action in actions"
          v-bind="{
            ...action.props || {}
          }"
          :key="action.key"
          :color="action.color || undefined"
          :text="action.flat || undefined"
          @click="handleAction(action.key)"
        >
          {{ action.text }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    htmlMode: {
      type: Boolean,
      default: false, // If true, text will be treated as HTML
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Array,
      required: true,
      validator: (actions) => actions.every(a => 'key' in a && 'text' in a),
    },
    // Internal prop to signal the Promise resolver
    resolve: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false, // Controls v-dialog visibility
      isResolved: false, // Prevent double resolution/destruction
    };
  },
  mounted() {
    // Show the dialog shortly after mounting to allow transitions
    this.$nextTick(() => {
      this.dialogVisible = true;
    });
  },
  methods: {
    handleAction(key) {
      if (this.isResolved) return;
      this.isResolved = true;
      this.resolve(key); // Resolve the promise with the clicked action's key
      this.dialogVisible = false; // Start closing animation
      // Destruction happens in 'onDialogInput' after animation
    },

    // Handles v-model changes (dialog closing animation finished)
    onDialogInput(isVisible) {
      // When dialog becomes hidden (isVisible is false) and we have resolved
      if (!isVisible && this.isResolved) {
        this.destroyComponent();
      }
      // Handle closing by clicking outside (if not persistent)
      else if (!isVisible && !this.persistent && !this.isResolved) {
        // Find a 'cancel' action (often key 0) or default to null/first action
        const cancelAction = this.actions.find(a => a.key === 0) || this.actions[0];
        this.handleAction(cancelAction ? cancelAction.key : null); // Resolve as cancel
      }
    },

    // Handle Escape key press (if not persistent)
    handleEsc(event) {
      if (!this.persistent) {
        // Find a 'cancel' action (often key 0) or default to null/first action
        const cancelAction = this.actions.find(a => a.key === 0) || this.actions[0];
        this.handleAction(cancelAction ? cancelAction.key : null); // Resolve as cancel
      }
    },

    // Clean up the component instance and DOM element
    destroyComponent() {
      this.$destroy(); // Destroy the Vue instance
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el); // Remove element from DOM
      }
    },
  },
};
</script>

<style scoped>
/* Add any specific styling if needed */
</style>
